
import firebase from 'firebase/compat/app';


export enum ExternalAuthError {

	/** The FirebaseUI library requires the browser to support web storage */
	WebStorageNotSupported,

	/** Firebase Auth raised an error */
	FirebaseAuthError,

	/** firebase.User.emailVerified is false */
	EmailNotVerified,
}


/**
 * Auth status when an error occurred or if auth is not available
 */
export interface ErrorExternalAuthState {

	status: 'error';
	error: ExternalAuthError;

	/** The error reported from Firebase if the error is FirebaseAuthError */
	firebaseAuthError?: firebase.auth.Error,
}


/**
 * Auth status when the service is in an unknown state, while logging in.
 */
export interface PendingExternalAuthState {
	status: 'pending'
}

/**
 * The firebase.User.sendEmailVerification() method was called and we are
 * waiting on the user to check their email and verify their email.
 */
export interface EmailPasswordVerificationEmailSentAuthState {
	status: 'email-password-verification-email-sent';
	user: firebase.User;
}


/**
 * Auth status when the service is in a known state of being signed out
 */
export interface SignedOutExternalAuthState {
	status: 'signed-out'
}


/**
 * Auth status when the service is in a known state of being signed in
 */
export interface SignedInExternalAuthState {
	status: 'signed-in';
	user: firebase.User;
	loginType: 'new' | 'from-persistence';
}



/**
 * A discriminated union of possible auth statuses. Access status-specific values by
 * comparing the status property to 'error', 'logged-out', or 'logged-in'
 */
export type ExternalAuthState = PendingExternalAuthState | EmailPasswordVerificationEmailSentAuthState | ErrorExternalAuthState | SignedOutExternalAuthState | SignedInExternalAuthState;
